import React, { useState, useEffect, useRef } from "react";
import "./UserInfoCard.scss";
import { getRoleName } from "../../utils/common";
import defaultImage from "../../assets/images/default-profile.png";
const BASE_URL = process.env.REACT_APP_API_URL

const UserInfoCard = ({user}) => {
  
  return (
    <div className="user-info">
      <div className="user-info-wrapper">
        <div className="left-info">
          <div className="img-area">
            <img className="user-image" src={BASE_URL+user.profileImagePath} alt="User" onError={(e)=> e.target.src=defaultImage}/>
          </div>
        </div>
        <div className="right-area toolTip">
          <div className="name">{user.firstName} {user.lastName}</div>
          <span>{user.firstName} {user.lastName}</span>
          <div className="position">{getRoleName(user.userRole)}</div>
        </div>
      </div>
    </div>
  );
};

export default UserInfoCard;
